import { AuthenticatedUser } from '@connect-x-app/shared-domain-models';
import { API_FACTORY } from '@connect-x-app/shared-utils';

import { HttpClient } from '../utils';

export const authenticateAdmin = (): Promise<AuthenticatedUser> =>
  HttpClient.get<AuthenticatedUser>(API_FACTORY.v3('admin/auth/me'));
